export {default as minproc} from 'node:process'
